import gql from "graphql-tag";

export const MUTATION_DOWNLOAD_SERIAL_NUMBER = gql`
  mutation ($eventId: String!) {
    downloadSerialNumber(eventId: $eventId)
  }
`;